import { render, staticRenderFns } from "./GatePassReport.vue?vue&type=template&id=35b5408a&"
import script from "./GatePassReport.vue?vue&type=script&lang=js&"
export * from "./GatePassReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports